import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var CannedResponseTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CannedResponseTransformer, _BaseTransformer);
  var _super = _createSuper(CannedResponseTransformer);
  function CannedResponseTransformer() {
    _classCallCheck(this, CannedResponseTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CannedResponseTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        createdOn: data.created_on,
        id: data.record_id,
        recordOwner: data.record_owner,
        subject: data.subject,
        content: data.content
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return CannedResponseTransformer;
}(BaseTransformer);